import { FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useUnderReview from './useUnderReview';

const UnderReview: FunctionComponent = () => {
  const { isLoading, provider } = useUnderReview();

  return (
    <PleaseWaitOverlay
      icon="alarm"
      title="The lender has received your application and it is under review"
      labelLine1={`You may receive further emails from our lender, ${provider}, informing you if anything further is needed.`}
      labelLine2={
        <p>
          If you&apos;re having trouble, you can reach out to Ideal4Finance
          loans team directly by clicking the{' '}
          <span className="font-semibold">&quot;Need Help&quot;</span> button in
          the header and calling our loans applications team to get some advice.
        </p>
      }
      isLoading={isLoading}
    />
  );
};

export default UnderReview;
